import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { FaFileAlt, FaRegCopy, FaPaperPlane } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import clipboardCopy from 'clipboard-copy';
import { dummyData, endpointForUrl } from '../../../../../services/dummy';
import { WEB_API_BASE_URL } from '../../../../../services/webApiAxios';
import { notification } from '../../../../../assets/constants/strings';
import './styles.scoped.scss';

// The request address bar: a read-only method pill (the method follows the
// selected endpoint), the URL, a copy + docs shortcut, and Send. The old
// GET/POST and v1 dropdowns are gone — the method is fixed per endpoint and the
// version already lives in the path.
const RequestForm = ({
  headers,
  apiKey,
  data,
  jsonInput,
  handleApiRequest,
  loading,
  setUrl,
  url,
  type,
}) => {
  const history = useHistory();
  const [requestType, setRequestType] = useState('GET');
  const [id, setId] = useState(null);

  useEffect(() => {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }, []);

  useEffect(() => {
    const item = dummyData.find((item) => item.endpoint === url);
    if (item) {
      setId(item.id + 3);
    }
    // The method follows the selected endpoint (most are GET; the AI query is POST).
    const catalogItem = item || endpointForUrl(url);
    setRequestType(catalogItem?.request || 'GET');
  }, [url]);

  const makeApiRequest = async () => {
    const config = {
      method: requestType,
      url,
    };

    if (headers) {
      config.headers = Object.fromEntries(
        headers.map(({ key, value }) => [key, value])
      );
    }
    if (apiKey) {
      config.headers = { ...config.headers, Authorization: `Bearer ${apiKey}` };
    }
    if (data) {
      config.data = data;
    }
    // POST endpoints (the AI query) carry a JSON body from the Body tab.
    if (jsonInput && requestType !== 'GET') {
      config.body = jsonInput;
    }
    if (type) {
      config.type = type;
    }

    handleApiRequest(config);
  };

  // The displayed path starts with /api and the base URL already ends in /api.
  const fullRequestUrl = () =>
    `${WEB_API_BASE_URL}${(url || '').replace(/^\/api/, '')}`;

  const copyUrl = () => {
    if (!url) return;
    clipboardCopy(fullRequestUrl())
      .then(() => notification('success', 'Request URL copied to clipboard.'))
      .catch(() => notification('info', 'Could not copy the request URL.'));
  };

  const hasUrl = (url || '').trim().length > 0;

  return (
    <div className='expl-addr'>
      <span
        className={`expl-addr__method ${
          requestType === 'POST' ? 'is-post' : 'is-get'
        }`}
        title='The method follows the selected endpoint'
      >
        {requestType}
      </span>
      <input
        className='expl-addr__url'
        type='text'
        placeholder='/api/v1/Section/Get/01LVNLRU6MDFMMSPRGWVA2SHUXOJGVY6FA'
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        aria-label='request URL'
      />
      <button
        className='expl-addr__icon'
        type='button'
        data-toggle='tooltip'
        data-placement='top'
        title='Copy the full request URL'
        disabled={!hasUrl}
        onClick={copyUrl}
      >
        <FaRegCopy />
      </button>
      <button
        className='expl-addr__icon'
        type='button'
        data-toggle='tooltip'
        data-placement='top'
        title='View documentation for this endpoint'
        onClick={() =>
          history.push(id ? '/api/documentation-' + id : '/api/documentation')
        }
      >
        <FaFileAlt />
      </button>
      <button
        className='expl-addr__send'
        type='button'
        onClick={makeApiRequest}
        disabled={loading || !hasUrl}
      >
        <FaPaperPlane /> {loading ? 'Sending…' : 'Send'}
      </button>
    </div>
  );
};

export default RequestForm;
